import { Component, effect, inject } from '@angular/core';
import { ChartData, ChartDataset } from 'chart.js';
import { ImpactService } from 'src/app/impact/services/impact.service';

@Component({
  selector: 'app-impact-per-day-graph',
  templateUrl: './impact-per-day-graph.component.html',
  styleUrl: './impact-per-day-graph.component.scss',
  standalone: false,
})
export class ImpactPerDayGraphComponent {
  impactService = inject(ImpactService);
  data?: ChartData;
  height: number = 500;
  showChart: boolean = true;
  constructor() {
    effect(() => {
      const impactData = this.impactService.impactReportData();
      if (impactData) {
        this.height = 50 + 30 * (impactData.trip.days ?? 0);
        this.data = impactData.impactPerDay as ChartData<'bar'>;
        this.data.datasets.forEach((dataset) => {
          (dataset as ChartDataset<'bar'>).barThickness = 20;
          (dataset as ChartDataset<'bar'>).barPercentage = 1.15;
        });
        this.updateChart();
      }
    });
  }

  type = 'bar';
  options = {
    scales: {
      y: {
        stacked: true,
        ticks: { color: '#475569' },
        grid: { display: false },
        border: { display: false },
      },
      x: {
        stacked: true,
        ticks: { display: false },
        grid: { display: false },
        border: { display: false },
        title: { display: false },
      },
    },
    indexAxis: 'y',
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
    },
  };

  plugins = [
    {
      tooltip: {
        mode: 'index',
      },
    },
  ];

  updateChart() {
    this.showChart = false;
    setTimeout(() => {
      this.showChart = true;
    }, 0);
  }
}
